import React, { useContext } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { func, object } from 'prop-types';
import { Button as AvonButton } from '@avon/component-library';
import { isMobile } from '../../../utils/getDeviceType';
// import loginBg from '../../../styles/assets/individual.png';
import HomeContext from '../../../home/HomeContext';

const useStyles = makeStyles(() => ({
  wrapper: e => (e.isMobile ? {
    padding: '15px 16px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    fontFamily: 'Montserrat',
  } : {
    padding: '50px 60px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    fontFamily: 'Montserrat',
  }),
  title: e => (e.isMobile ? {
    fontSize: 22,
    fontWeight: 500,
    lineHeight: '30px',
    color: '#181818',
  } : {
    fontSize: 22,
    fontWeight: 500,
    lineHeight: '30px',
    color: '#181818',
  }),
  desc: e => (e.isMobile ? {
    fontSize: 14,
    lineHeight: '20px',
    color: '#546264',
    margin: '16px 0',
  } : {
    fontSize: 18,
    lineHeight: '26px',
    color: '#546264',
    margin: '18px 0',
  }),
  imgContiner: {
    width: '100%',
    '& img': {
      width: '100%',
    },
  },
}));

const IndividualDetail = ({
  setclickId,
  notifycationDetail: {
    icon = {}, contentMap = {}, header, action,
  },
  redirectTo,
  snsInfo: { button },
}) => {
  const theme = useTheme();
  const classes = useStyles({ language: 'not ar', isMobile: isMobile() });
  const [, dispatch] = useContext(HomeContext);

  const iconMap = {
    [useMediaQuery(theme.breakpoints.up('300'))]: 'mdpi',
    [useMediaQuery(theme.breakpoints.up('450'))]: 'hdpi',
    [useMediaQuery(theme.breakpoints.up('600'))]: 'xhdpi',
    [useMediaQuery(theme.breakpoints.up('900'))]: 'xxhdpi',
    [useMediaQuery(theme.breakpoints.up('1200'))]: 'xxxhdpi',
  };
  const image = icon[iconMap.true];
  console.log('individual', image);


  const handleClickCloseBtn = () => {
    if (!action
      || (action.indexOf('dashboard') === -1
      && action.indexOf('helpsupport') === -1
      && action.indexOf('viewalllead') === -1
      && action.indexOf('viewprp') === -1)
    ) {
      setclickId('');
      return;
    }
    const linkList = action ? action.split('/') : [];
    const pageName = linkList[linkList.length - 1];
    let type;
    let subType;

    switch (pageName) {
      case 'dashboard':
        type = 'home';
        subType = null;
        break;
      case 'helpsupport':
        type = 'help';
        subType = null;
        break;
      case 'viewalllead':
        type = 'lma';
        subType = 'leads';
        break;
      case 'viewprp':
        type = 'personalPage';
        subType = 'myProfile';
        break;
      default:
        break;
    }
    setclickId('');
    dispatch({ currentPage: subType || type });
    redirectTo({
      type, subType, hasFooter: false, params: '',
    });
  };


  return (
    <Box className={classes.wrapper}>
      <Box className={classes.title}>
        {header}
      </Box>
      <Box className={classes.desc}>
        {contentMap.content0}
      </Box>
      {
        contentMap.content1 && (
          <Box className={classes.desc}>
            {contentMap.content1}
          </Box>
        )
      }
      {
        contentMap.content2 && (
          <Box className={classes.desc}>
            {contentMap.content2}
          </Box>
        )
      }
      {
        image && (
          <Box className={classes.imgContiner}>
            <img src={image} alt="img" />
          </Box>
        )
      }
      <Box style={{ width: '100%', marginTop: 22 }}>
        <AvonButton priority="secondary" onClick={handleClickCloseBtn}>{button.close}</AvonButton>
      </Box>
    </Box>
  );
};

IndividualDetail.propTypes = {
  notifycationDetail: object,
  setclickId: func,
  redirectTo: func,
  snsInfo: object,
};

export default IndividualDetail;
